/*
 * @Description 组件 NavbarCard 菜单面板
 * @Author 
 * @Date 
 */
/* HTML */
<template>
	<div class="layout_left">
        <el-menu
            class="el-menu-vertical-demo"
            @open="handleOpen"
            @close="handleClose"
            :default-active="onRoutes"
            :collapse="isCollapse"
            :unique-opened="true"
            router
        >
        	<div style="text-align: center;padding-bottom: 10px;">
        		<span class="dp-mine-bg"></span>
        		<span class="user-info-text" v-if="!isCollapse">{{$store.state.account}}</span>
        		<span class="user-info-text" v-if="!isCollapse">{{$store.getters.getUserRoleName}}</span>
        	</div>
        	
            <template v-for="one in items">
                <template v-if="one.children">
                    <el-submenu
                        :index="one.path"
                        :key="one.id"
                    >
                        <template slot="title">
                            <i :class="one.icon"></i>
                            <span>{{one.name}}</span>
                        </template>
                        <template v-for="two in one.children">
                            <template v-if="two.children">
                                <el-submenu
                                    :key='two.id'
                                    :index="two.path"
                                >
                                    <template slot="title">
                                        <span>{{two.name}}</span>
                                    </template>
                                    <template v-for="children in two.children">
                                        <el-menu-item
                                            :key='children.id'
                                            :index='children.path'
                                        >{{children.name}}
                                        </el-menu-item>
                                    </template>
                                </el-submenu>
                            </template>
                            <template v-else>
                                <el-menu-item-group :key='two.id'>
                                    <el-menu-item :index='two.path'>{{two.name}}</el-menu-item>
                                </el-menu-item-group>
                            </template>
                        </template>
                    </el-submenu>
                </template>
                <template v-else>
                    <el-menu-item
                        :index="one.path"
                        :key="one.id"
                    >
                        <template>
                            <i :class="one.icon"></i>
                            <span>{{one.name}}</span>
                        </template>
                    </el-menu-item>
                </template>
            </template>
            <template>
                <el-menu-item class="not-nav-item" @click="toggleMenue" title="收起/展开 菜单">
                    <template>
                        <i v-if="isCollapse" class="el-icon-s-unfold" style="color: #e6e6e6;"></i>
                        <i v-else="isCollapse" class="el-icon-s-fold" style="color: #e6e6e6;"></i>
                    </template>
                </el-menu-item>
            </template>
        </el-menu>
    </div>
</template>

/* JS */
<script>
	// 组件 request
	import request from '@/request/request';
	// 组件 公共方法
	import GlobalFun from '@/global/global-function';
	import { mapMutations } from 'vuex';
	// API 资源
	import ApiOam from '@/request/api-oam';
	
	export default {
		/**
		 * @Des 组件名
		 * @Auth
		 * @Date 
		 */
        name: "Navbar",
        
        /**
		 * @Des 组件注册
		 * @Auth
		 * @Date 
		 */
        components: {
        	
        },// components
        
        /**
		 * @Des 属性值
		 * @Auth
		 * @Date 
		 */
        props: {
        	
        },// props
        
        /**
		 * @Des 数据定义
		 * @Auth
		 * @Date 
		 */
		data() {
			return {
				isCollapse: this.navbarFlag,
				/**
				 * @Des 菜单数据
				 * @Auth 
				 * @Date 
				 */
				items: [],// 导航 菜单
				userRouter: [],
				
			}
		},// data
		
		/**
		 * @Des 初始化
		 * @Auth
		 * @Date 
		 */
		created() {
			
		},// created
		
		/**
		 * @Des 加载完成
		 * @Auth
		 * @Date 
		 */
		mounted() {
			// 模拟菜单数据
			//this.initModelRows();
			// 查询资源
			this.searchResource();
		},// mounted
		
		/**
		 * @Des 销毁之前
		 * @Auth
		 * @Date 
		 */
		beforeDestroy() {
			
		},// beforeDestroy
		
		/**
		 * @Des 销毁
		 * @Auth
		 * @Date 
		 */
		destroyed() {
			
		},// destroyed
		
		/**
		 * @Des 方法定义
		 * @Auth
		 * @Date 
		 */
		methods: {
			/**
		     * @Des 查询 资源
		     * @Auth 
		     * @Date 
		     */
			searchResource() {
				//return false;
				// 交互
				request.postJsonRequest(ApiOam.Search_Role_Resources_Uri, {
					Role: this.$store.state.userRole,
					showType: this.$store.state.showType,// 20,// 1 隧道； 2 通用版
					resourceTypes: [1],
				}).then(result => {
					
					this.userRouter = [];
					this.items = [];
					if (result.total > 0) {
						
						let rows = GlobalFun.dataToTree(Object.assign([], result.rows), {
							id: 'resourceId',
							pid: 'resourceParentId',
							children: 'children',
							icon: 'resourceIcons',
							path: 'resourceUri',
							name: 'resourceName'
						});
						// 遍历 一级菜单
						rows.forEach((row, index) => {
							// 有二级菜单
							if (!this.$checkEmpty(row.children)) {
								// 遍历 二级菜单
								row.children.forEach((r, i) => {
									if (!this.$checkEmpty(r.resourceUri)) {
										// 二级菜单 有地址
										this.userRouter.push(r.resourceUri);
									}
								});
							} else if (!this.$checkEmpty(row.resourceUri)) {
								// 一级菜单有地址
								this.userRouter.push(row.resourceUri);
							}
						});
						this.items = Object.assign([], rows);
					}
					this.$store.dispatch("commitUserRouter", JSON.stringify(this.userRouter));
				}).catch(error => {
					console.error('查询资源异常', ApiOam.Search_Role_Resources_Uri, error);
				});
			},
			
			/**
		     * @Des 模拟菜单数据
		     * @Auth 
		     * @Date 
		     */
			initModelRows() {
				const _rows = [
					  {
					    "resourceId": "T01", "resourceIcons": "iconfont el-icon-my_yiliaohangyedeICON-", "resourceName": "定位",
					    "resourceUri": "/manager/location", "resourceParentId": "0",
					    "resourceLevel": 1, "resourceSort": 1, "resourceType": 1, "accessType": 1, "required": 0,
					    "displayMode": "1,2,3","showType": "20"
					  },{
					    "resourceId": "T0101", "resourceIcons": "", "resourceName": "定位监控",
					    "resourceUri": "/manager/location/monitor", "resourceParentId": "T01",
					    "resourceLevel": 2, "resourceSort": 1, "resourceType": 1, "accessType": 1, "required": 0,
					    "displayMode": "1,2,3","showType": "20"
					  },{
					    "resourceId": "T0102", "resourceIcons": "", "resourceName": "历史轨迹",
					    "resourceUri": "/manager/location/history", "resourceParentId": "T01",
					    "resourceLevel": 2, "resourceSort": 2, "resourceType": 1, "accessType": 1, "required": 0,
					    "displayMode": "1,2,3","showType": "20"
					  },{
					    "resourceId": "T0103", "resourceIcons": "", "resourceName": "电子围栏",
					    "resourceUri": "/manager/location/fence", "resourceParentId": "T01",
					    "resourceLevel": 2, "resourceSort": 3, "resourceType": 1, "accessType": 1, "required": 0,
					    "displayMode": "1,2,3","showType": "20"
					  },{
					    "resourceId": "T02", "resourceIcons": "iconfont el-icon-my_zuoyebaojing", "resourceName": "报警",
					    "resourceUri": "/manager/alarm", "resourceParentId": "0",
					    "resourceLevel": 1, "resourceSort": 2, "resourceType": 1, "accessType": 1, "required": 0,
					    "displayMode": "1,2,3","showType": "20"
					  },{
					    "resourceId": "T0201", "resourceIcons": "", "resourceName": "实时报警",
					    "resourceUri": "/manager/alarm/real", "resourceParentId": "T02",
					    "resourceLevel": 2, "resourceSort": 1, "resourceType": 1, "accessType": 1, "required": 0,
					    "displayMode": "1,2,3","showType": "20"
					  },{
					    "resourceId": "T0202", "resourceIcons": "", "resourceName": "历史报警",
					    "resourceUri": "/manager/alarm/history", "resourceParentId": "T02",
					    "resourceLevel": 2, "resourceSort": 2, "resourceType": 1, "accessType": 1, "required": 0,
					    "displayMode": "1,2,3","showType": "20"
					  },{
					    "resourceId": "T03", "resourceIcons": "iconfont el-icon-my_shujucaiji2", "resourceName": "数据",
					    "resourceUri": "/manager/info", "resourceParentId": "0",
					    "resourceLevel": 1, "resourceSort": 3, "resourceType": 1, "accessType": 1, "required": 0,
					    "displayMode": "1,2,3","showType": "2"
					  },{
					    "resourceId": "T0301", "resourceIcons": "", "resourceName": "人员信息采集",
					    "resourceUri": "/manager/info/user", "resourceParentId": "T03",
					    "resourceLevel": 2, "resourceSort": 1, "resourceType": 1, "accessType": 1, "required": 0,
					    "displayMode": "1,2,3","showType": "2"
					  },{
					    "resourceId": "T0302", "resourceIcons": "", "resourceName": "车辆信息采集",
					    "resourceUri": "/manager/info/car", "resourceParentId": "T03",
					    "resourceLevel": 2, "resourceSort": 2, "resourceType": 1, "accessType": 1, "required": 0,
					    "displayMode": "1,2,3","showType": "2"
					  },{
					    "resourceId": "T0303", "resourceIcons": "", "resourceName": "绑定记录",
					    "resourceUri": "/manager/info/bindingRecords", "resourceParentId": "T03",
					    "resourceLevel": 2, "resourceSort": 3, "resourceType": 1, "accessType": 1, "required": 0,
					    "displayMode": "1,2,3","showType": "2"
					  },{
					    "resourceId": "T04", "resourceIcons": "iconfont el-icon-my_shebeiguanli1", "resourceName": "设备",
					    "resourceUri": "/manager/device", "resourceParentId": "0",
					    "resourceLevel": 1, "resourceSort": 4, "resourceType": 1, "accessType": 1, "required": 0,
					    "displayMode": "1,2,3","showType": "2"
					  },{
					    "resourceId": "T0401", "resourceIcons": "", "resourceName": "定位基站",
					    "resourceUri": "/manager/device/bs", "resourceParentId": "T04",
					    "resourceLevel": 2, "resourceSort": 1, "resourceType": 1, "accessType": 1, "required": 0,
					    "displayMode": "1,2,3","showType": "2"
					  },{
					    "resourceId": "T0402", "resourceIcons": "", "resourceName": "定位标签",
					    "resourceUri": "/manager/device/tag", "resourceParentId": "T04",
					    "resourceLevel": 2, "resourceSort": 2, "resourceType": 1, "accessType": 1, "required": 0,
					    "displayMode": "1,2,3","showType": "2"
					  },{
					    "resourceId": "T90", "resourceIcons": "iconfont el-icon-my_shebeiguanli1", "resourceName": "隧道",
					    "resourceUri": "/manager/tunnel", "resourceParentId": "0",
					    "resourceLevel": 1, "resourceSort": 90, "resourceType": 1, "accessType": 1, "required": 0,
					    "displayMode": "1,2,3","showType": "2"
					  },{
					    "resourceId": "T0501", "resourceIcons": "", "resourceName": "今日进场情况",
					    "resourceUri": "/manager/tunnel/today", "resourceParentId": "T90",
					    "resourceLevel": 2, "resourceSort": 1, "resourceType": 1, "accessType": 1, "required": 0,
					    "displayMode": "1,2,3","showType": "2"
					  },{
					    "resourceId": "T0502", "resourceIcons": "", "resourceName": "历史进场记录",
					    "resourceUri": "/manager/tunnel/history", "resourceParentId": "T90",
					    "resourceLevel": 2, "resourceSort": 2, "resourceType": 1, "accessType": 1, "required": 0,
					    "displayMode": "1,2,3","showType": "2"
					  },{
					    "resourceId": "T100", "resourceIcons": "el-icon-setting", "resourceName": "系统",
					    "resourceUri": "/manager/system", "resourceParentId": "0",
					    "resourceLevel": 1, "resourceSort": 100, "resourceType": 1, "accessType": 1, "required": 0,
					    "displayMode": "1","showType": "2"
					  },{
					    "resourceId": "T10001", "resourceIcons": "", "resourceName": "角色授权",
					    "resourceUri": "/manager/system/account", "resourceParentId": "T100",
					    "resourceLevel": 2, "resourceSort": 1, "resourceType": 1, "accessType": 1, "required": 0,
					    "displayMode": "1","showType": "2"
					  },{
					    "resourceId": "T10002", "resourceIcons": "", "resourceName": "参数配置",
					    "resourceUri": "/manager/system/paramConfig", "resourceParentId": "T100",
					    "resourceLevel": 2, "resourceSort": 2, "resourceType": 1, "accessType": 1, "required": 0,
					    "displayMode": "1","showType": "2"
					  }
					
					
					];
					
					this.userRouter = [];
					this.items = [];
					if (true) {
						
						let rows = GlobalFun.dataToTree(Object.assign([], _rows), {
							id: 'resourceId',
							pid: 'resourceParentId',
							children: 'children',
							icon: 'resourceIcons',
							path: 'resourceUri',
							name: 'resourceName'
						});
						// 遍历 一级菜单
						rows.forEach((row, index) => {
							// 有二级菜单
							if (!this.$checkEmpty(row.children)) {
								// 遍历 二级菜单
								row.children.forEach((r, i) => {
									if (!this.$checkEmpty(r.resourceUri)) {
										// 二级菜单 有地址
										this.userRouter.push(r.resourceUri);
									}
								});
							} else if (!this.$checkEmpty(row.resourceUri)) {
								// 一级菜单有地址
								this.userRouter.push(row.resourceUri);
							}
						});
						this.items = Object.assign([], rows);
					}
					this.$store.dispatch("commitUserRouter", JSON.stringify(this.userRouter));
			},
			
			/**
		     * @Des 点击资源
		     * @Auth 
		     * @Date 
		     */
			handleItem(row) {
				// 空值 中止
				if (this.$checkEmpty(row) || this.$checkEmpty(row.path)) return false;
				
				const path = row.path;
				// 页面跳转
              	this.$router.replace({path: path}, ()=>{}, ()=>{});
            	
            	// 隐藏 menu
            	this.$emit('toggleMenuItem', false);
				// 隐藏 menu
            	setTimeout(() => {
            		this.$emit('toggleMenuItem', true);
            	}, 800);
            	
			},
			
			/**
			 * @Des 提取模块名称
			 * @Auth 
			 * @Date 
			 */
			extrackSubName(path) {
				// 空值 中止
				if (this.$checkEmpty(path) || this.$checkEmpty(this.items)) return '';
				
				// 模块名称
				let subName = '';
				const items = Object.assign([], this.items);
				// 遍历 提取模块名称
				items.forEach((row, index) => {
					// 已有值 跳过
					if (!this.$checkEmpty(subName)) return false;
					
					const children = !this.$checkEmpty(row.children) ? Object.assign([], row.children) : [];
					// 遍历 比对
					children.forEach((r, i) => {
						// 已有值 跳过
						if (!this.$checkEmpty(subName)) return false;
						
						if (r.path == path) {
							// 模块名称
							subName = r.name;
						}
					});
				});
				return subName;
			},
			
			/**
             * @Des 处理打开
             * @Auth 
             * @Date 
             */
            handleOpen(key, keyPath) {},
            /**
             * @Des 处理关闭
             * @Auth 
             * @Date 
             */
            handleClose(key, keyPath) {},
			/**
             * @Des 收起/打开 左侧菜单
             * @Auth 
             * @Date 
             */
            toggleMenue() {
                this.isCollapse = !this.isCollapse;
                this.$emit('navbarFlagChange', this.isCollapse);
            },
			
			/**
			 * @Des 提交用户路由
			 * @Auth 
			 * @Date 
			 */
			...mapMutations([
				'commitUserRouter'
			]),
		},// methods
		
		/**
		 * @Des 监听
		 * @Auth
		 * @Date 
		 */
		watch: {
			
		},// watch
		
		/**
		 * @Des 实时计算
		 * @Auth
		 * @Date 
		 */
		computed: {
			onRoutes() {
				//return this.$route.path.replace("/", "");
				const route = this.$route;
				const { meta, path } = route;
				// if set path, the sidebar will highlight the path you set
				
				if (meta.activeMenu) {
					
					// 延迟执行
					this.$nextTick(() => {
						// 提取模块名称
						const subName = this.extrackSubName(meta.activeMenu);
						// 发布消息 路由 页
						this.$pubsub.publish('routerSubName', subName);
					});
					
					return meta.activeMenu;
				}
				
				// 延迟执行
				this.$nextTick(() => {
					// 提取模块名称
					const subName = this.extrackSubName(path);
					// 发布消息 路由 页
					this.$pubsub.publish('routerSubName', subName);
				});
				
				return path;
			},// onRoutes
			
		},// computed
		
    }// export default
</script>

/* CSS */
<style lang="scss" scoped>
	
</style>



// WEBPACK FOOTER //
// src/components_index/AppNavbar/index.vue